import { Model, belongsTo } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  desk: belongsTo('graphql/desk'),

  inviteId: attr('string'),

  startTime: attr('int'),
  endTime: attr('int'),
});
